import React, {FC, ReactNode} from 'react';
// import {usePageLoading} from 'core/next/hooks/usePageLoading';
// import {BreadCrumbProvider} from 'modules/breadcrumbs/providers/BreadCrumbProvider';
// import {useUrlCapture} from 'modules/skeleton/hooks/useUrlCapture';
// import {SkeletonRoot} from 'modules/skeleton/components/SkeletonRoot';

interface IProps {
    children: ReactNode;
}

export const Page: FC<IProps> = ({children}) => {
    // const isPageLoading = usePageLoading();
    // const nextUrl = useUrlCapture();

    // if (!isPageLoading) {
    //     return (
    //         <>
    //             <BreadCrumbProvider />
    //             {children}
    //         </>
    //     );
    // }

    // return <SkeletonRoot nextUrl={nextUrl}>{children}</SkeletonRoot>;
    return <>{children}</>;
};
